import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onReady", "onSetup", "disableMainPadding", "disableHeaderPadding", "disableMargin"];
var _dec, _class, _class2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import videojs from 'video.js';
import Vimeo from '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.cjs';
import 'videojs-markers';
import 'videojs-youtube';
import s from 'video.js/dist/video-js.min.css';
import fi from './fi.json';
import sv from './sv.json';
import fr from './fr.json';
Vimeo.prototype.load = function () {};
Vimeo.prototype.preload = function () {};
Vimeo.prototype.reset = function () {};
require('@silvermine/videojs-quality-selector')(videojs);
var VideoPlayer = (_dec = withStyles(s), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(VideoPlayer, _React$Component);
  var _super = _createSuper(VideoPlayer);
  function VideoPlayer() {
    _classCallCheck(this, VideoPlayer);
    return _super.apply(this, arguments);
  }
  _createClass(VideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        onReady = _this$props.onReady,
        onSetup = _this$props.onSetup,
        disableMainPadding = _this$props.disableMainPadding,
        disableHeaderPadding = _this$props.disableHeaderPadding,
        disableMargin = _this$props.disableMargin,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var options = _objectSpread({
        techOrder: ['vimeo', 'youtube', 'html5']
      }, rest);
      videojs.addLanguage('fi-FI', fi);
      videojs.addLanguage('sv-SE', sv);
      videojs.addLanguage('fr-FR', fr);
      videojs.hook('setup', onSetup);

      // instantiate Video.js
      this.player = videojs(this.videoNode, options, function onPlayerReady() {
        var _this = this;
        this.resizeVideoJS = function () {
          var el = _this.el_; // eslint-disable-line no-underscore-dangle
          var aspectRatio;
          if (_.get(_this, 'tech_.ytPlayer')) {
            aspectRatio = _.get(_this, 'tech_.ytPlayer.g.g.height', 0) / _.get(_this, 'tech_.ytPlayer.g.g.width', 0);
          } else if (_.get(_this, 'tech_._player')) {
            aspectRatio = _.get(_this, 'tech_._player.element.height', 0) / _.get(_this, 'tech_._player.element.width', 0);
          } else {
            aspectRatio = _this.videoHeight() / _this.videoWidth();
          }
          var header = document.querySelector('header');
          var main = document.querySelector('main');
          var videoNoteBtn = document.querySelector('#add-video-note-btn');
          var videoNoteBtnHeight = (videoNoteBtn && videoNoteBtn.offsetHeight || 40) + 10;
          var headerHeight = header && header.offsetHeight || 55;
          if (disableHeaderPadding) {
            headerHeight = 0;
          }
          var mainPadding = main && parseInt(window.getComputedStyle(main, null).getPropertyValue('padding-top'), 10) || 15;
          if (disableMainPadding) {
            mainPadding = 0;
          }
          var restMargins = 20;
          var width = el.parentElement.offsetWidth;
          var height = el.parentElement.offsetHeight;
          var margin = width > 992 ? 24 : 0;
          if (!disableMargin) {
            width -= margin;
          }
          if (Number.isNaN(aspectRatio)) {
            _this.width(width);
            return;
          }
          if (window.innerWidth < 992) {
            var newWidth = width;
            var newHeight = width * aspectRatio;
            if (newHeight + headerHeight + mainPadding + restMargins > window.innerHeight) {
              newHeight = window.innerHeight - headerHeight - mainPadding - restMargins;
              newWidth = newHeight / aspectRatio;
            }
            _this.width(newWidth);
            _this.height(newHeight);
            return;
          }
          var calculatedHeight = width * aspectRatio;
          height -= videoNoteBtnHeight;
          if (calculatedHeight > height) {
            _this.width(height / aspectRatio);
            _this.height(height);
          } else {
            _this.width(width);
            _this.height(calculatedHeight);
          }
        };
        window.addEventListener('resize', this.resizeVideoJS);
        this.resizeVideoJS();
        this.on('loadedmetadata', function () {
          _this.resizeVideoJS();
        });
        onReady(this);
      });
      this.player.on('play', function () {
        if (_this2.props.youtube && _this2.player.getChild('LoadingSpinner')) {
          _this2.player.removeChild('LoadingSpinner');
        }
      });
    }

    // destroy player on unmount
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onUnmount();
      window.removeEventListener('resize', this.player.resizeVideoJS);
      // this.player.dispose();
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        muted = _this$props2.muted,
        playsInline = _this$props2.playsInline,
        controls = _this$props2.controls;
      return /*#__PURE__*/_jsx("div", {
        "data-vjs-player": true
      }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, this.props.goToNextSection), /*#__PURE__*/React.createElement("video", {
        // eslint-disable-line jsx-a11y/media-has-caption
        className: "video-js vjs-default-skin",
        controls: controls,
        preload: "auto"
        // type={this.props.mimetype} // `${mimetype} codecs="H.264/MPEG-4"` // possible solution with codecs
        ,
        poster: this.props.poster,
        ref: function ref(node) {
          _this3.videoNode = node;
        },
        muted: muted,
        playsInline: playsInline
      }));
    }
  }]);
  return VideoPlayer;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  poster: undefined,
  onUnmount: function onUnmount() {
    return null;
  },
  goToNextSection: undefined,
  playsInline: false,
  muted: false,
  youtube: null,
  onSetup: function onSetup() {
    return null;
  },
  disableMainPadding: false,
  disableHeaderPadding: false,
  disableMargin: false,
  controls: true
}), _class2)) || _class);
export { VideoPlayer as default };